import { Button, Popover, Tooltip } from '../..';
import { ContentBlock, ContentState, DraftDecorator } from 'draft-js';
import { DraftDecoratorComponentProps, EntityTypes } from '../types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLink, faUnlink } from '@fortawesome/pro-regular-svg-icons';
import { findEntity } from '../utils';
import React from 'react';

export interface LinkDecoratorProps {
    unlink: (blockKey: string, start: number, end: number) => void;
}

const createVariableEntityStrategy = () => {
    return (contentBlock: ContentBlock, callback: (start: number, end: number) => void, contentState: ContentState) => {
        findEntity(contentBlock, contentState, EntityTypes.Link, callback);
    };
};

const LinkDecorator = (props: DraftDecoratorComponentProps & LinkDecoratorProps) => {
    const { contentState, entityKey, blockKey, start, end, unlink, children } = props;
    let url: string | undefined;
    if (entityKey) {
        const entity = contentState.getEntity(entityKey);
        if (entity.getType() === EntityTypes.Link) {
            const data: { url: string } = entity.getData();
            url = data.url;
        }
    }

    return (
        <span className="rain-editor-link">
            <Popover
                trigger="hover"
                placement="bottom"
                content={
                    <div className="rain-editor-link-popover">
                        <Tooltip title={url}>
                            <div className="rain-editor-link-popover-url">{url}</div>
                        </Tooltip>
                        <Tooltip title="Unlink">
                            <Button
                                size="small"
                                title="Unlink"
                                onMouseDown={(e) => {
                                    e.preventDefault();
                                    unlink(blockKey, start, end);
                                }}>
                                <FontAwesomeIcon icon={faUnlink} />
                            </Button>
                        </Tooltip>
                    </div>
                }>
                {children}
                <span className="rain-editor-link-indicator">
                    <FontAwesomeIcon icon={faExternalLink} />
                </span>
            </Popover>
        </span>
    );
};

export const getLinkEntityDecorator = (props: LinkDecoratorProps): DraftDecorator => {
    return {
        strategy: createVariableEntityStrategy(),
        component: LinkDecorator,
        props: { unlink: props.unlink },
    };
};
